<template>
  <ElButton
    v-if="props.isShowOpenDialogButton"
    type="primary"
    plain
    size="small"
    :class="bem.e('handler')"
    @click="open"
    v-permission="permission"
  >
    {{ t('ep.attachment.manageAttachment') }}({{ modelValue?.length || 0 }})
  </ElButton>
  <AttachmentDialog>
    <div style="margin-bottom: 10px; text-align: right">
      <EpButtons
        v-if="props.openType === 'dialog' && mode !== 'browse'"
        type="primary"
        :list="[
          {
            name: t('ep.attachment.addAttachment'),
            type: 'primary',
            onClick: addAttachment,
          },
        ]"
      />
    </div>

    <EpTable
      ref="tableRef"
      :class="`${bem.b()} ${prepareClassNames()}`"
      :style="{
        ...prepareStyles(),
      }"
      :columns="columns"
      :action-buttons="actionButtons"
      actionColWidth="110"
      :data="modelValue"
      v-bind="props"
    >
    </EpTable>
  </AttachmentDialog>
</template>
<script setup lang="ts">
import { createNameSpace } from '@el-plus/utils/bem'
import { prepareClassNames, prepareStyles } from '@el-plus/utils/props'
import { attachmentProps } from './attachment'
import EpTable from '@el-plus/components/table'
import { useAttachment } from './use-attachment'
import type { TableProps } from '@el-plus/components/table'
import { useDialog } from '@el-plus/hooks/dialog/use-dialog'
import { useLocale } from '@el-plus/hooks/use-locale'
import { ElButton } from 'element-plus'
import { vPermission } from '@el-plus/directives'

const { t } = useLocale()
defineOptions({
  name: 'EpAttachment',
  inheritAttrs: false,
})
const bem = createNameSpace('attachment')
const props = defineProps(attachmentProps)
const modelValue = defineModel<TableProps['data']>()
const {
  columns,
  actionButtons,
  addAttachment,
  isNormalOpen,
  permission,
  onConfirm,
  onCancel,
  mode,
} = useAttachment(props, {
  data: modelValue,
})
const AttachmentDialog = useDialog({
  width: isNormalOpen ? '' : 850,
  center: true,
  title: isNormalOpen ? '' : t('ep.attachment.manageAttachment'),
  modal: !isNormalOpen,
  showClose: !isNormalOpen,
  showFooter: !isNormalOpen,
  transition: isNormalOpen ? '' : 'dialog-fade',
  modalClass: bem.em(
    'dialog',
    props.openType === 'normal' ? props.openType : '',
  ),
  templatePromiseClass: bem.e('promise'),
  onConfirm: async (resolve) => {
    onConfirm(resolve)
  },
  onCancel: (resolve) => {
    onCancel(resolve)
  },
})
const open = AttachmentDialog.open
if (isNormalOpen) {
  open()
}
defineExpose({
  open,
})
</script>
